<template lang="pug">
	div.contenedor(ref="contenedor", v-if="imagenes.length > 0")
		.imagen(:style="estiloWrapper")
			.capaMultimedia(
				v-for="contenido in imagenes"
				:key="contenido.ArchivoID"
				:style="{width: anchoContainer + 'px'}")

				// En caso de que sea una imagen
				div.capaImagen(:style="contenido.estilo", v-if="contenido.Tipo === 'imagen'")

				// En caso de que sea un vídeo
				div.capaVideo(:style="contenido.estilo", v-if="contenido.Tipo === 'video'")
					video(:style="contenido.estilo", :src="contenido.src", controls="true")

				// En caso de que sea un vídeo de youtube
				iframe(
					v-if="contenido.Tipo === 'youtube'"
					width="100%",
					height="400",
					:src="'https://www.youtube-nocookie.com/embed/' + contenido.YoutubeID",
					frameborder="0",
					allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
					allowfullscreen)
		.capaPuntos(v-if="imagenes.length > 1")
			div.text-center
				span.m-2.punto(
					v-for="(imagen, ind) in imagenes"
					:key="imagen.ArchivoID"
					@click="verImagen(ind)"
					style="cursor:pointer;color: white;font-size:1.4em;"
					:class="(i === ind) ? 'active' : ''"
				)
					span.fa.fa-circle
		.capaFlecha.siguiente(@click="siguiente()", v-if="imagenes.length > 1")
			span.fa.fa-arrow-right
		.capaFlecha.anterior(@click="anterior()", v-if="imagenes.length > 1")
			span.fa.fa-arrow-left
</template>

<script>
export default {
	props: ['datos'],
	data () {
		return {
			i: 0,
			anchoContainer: 0,
			estiloWrapper: {}
		}
	},
	computed: {
		imagenes () {
			let imagenes = this.datos.Archivos.filter(ar => (ar.Tipo === 'imagen' || ar.Tipo === 'video'))
			imagenes = imagenes.map(im => {
				im.estilo = {
					width: this.anchoContainer + 'px'
				}

				if (im.Tipo === 'imagen') {
					im.src = '/src/modulos/muro/php/api/verImagen.php?ArchivoID=' + im.ArchivoID
					im.estilo.backgroundImage = 'url(' + im.src + ')'
				} else if (im.Tipo === 'video') {
					im.src = '/src/modulos/muro/php/api/verVideo.php?ArchivoID=' + im.ArchivoID
					im.estilo.height = '400px'
				}
				return im
			})

			imagenes = this.datos.Youtube.reduce((ant, im) => {
				im.estilo = {
					width: this.anchoContainer + 'px'
				}
				im.Tipo = 'youtube'
				ant.push(im)
				return ant
			}, imagenes)

			return imagenes
		}
	},
	mounted () {
		this.calculaDimensiones()
		window.addEventListener('resize', this.calculaDimensiones)
		window.setTimeout(() => {
			this.calculaDimensiones()
		}, 200)
	},
	beforeDestroy () {
		window.removeEventListener('resize', this.calculaDimensiones)
	},
	methods: {
		calculaDimensiones () {
			const cont = this.$refs.contenedor
			if (cont) {
				const ancho = cont.offsetWidth
				this.anchoContainer = ancho
				this.estiloWrapper = {
					width: (this.imagenes.length * this.anchoContainer) + 'px',
					transform: 'translateX(' + (this.i * this.anchoContainer * -1) + 'px)'
				}
			}
		},
		siguiente () {
			this.i++
			if (this.i >= this.imagenes.length) {
				this.i = 0
			}

			this.estiloWrapper = {
				width: (this.imagenes.length * this.anchoContainer) + 'px',
				transform: 'translateX(' + (this.i * this.anchoContainer * -1) + 'px)'
			}

			this.$forceUpdate()
		},
		anterior () {
			this.i--
			if (this.i < 0) {
				this.i = this.imagenes.length - 1
			}

			this.estiloWrapper = {
				width: (this.imagenes.length * this.anchoContainer) + 'px',
				transform: 'translateX(' + (this.i * this.anchoContainer * -1) + 'px)'
			}

			this.$forceUpdate()
		},
		verImagen (ind) {
			this.i = ind
			this.estiloWrapper = {
				width: (this.imagenes.length * this.anchoContainer) + 'px',
				transform: 'translateX(' + (this.i * this.anchoContainer * -1) + 'px)'
			}

			this.$forceUpdate()
		}
	}
}
</script>

<style scoped>
.contenedor {
	position: relative;
	display: block;
	height: 400px;
	width: 100%;
	overflow: hidden;
}
.imagen {
	position: relative;
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	height: 400px;
	background-color: black;
	transition: transform 1000ms cubic-bezier(0.19, 1, 0.22, 1);
}

.capaImagen {
	position: relative;
	display: inline-block;
	height: 400px;
	background-position: center;
	background-repeat: no-repeat;
	background-size: contain;
}

.capaVideo {
	position: relative;
	display: inline-block;
	height: 400px;
	width: 100%;
}
.capaMultimedia {
	position: relative;
	display: inline-block;
	height: 400px;
}

.capaPuntos {
	position: absolute;
	display: block;
	bottom: 10px;
	left: 20%;
	right: 20%;
	text-align: center;
}

.punto {
	opacity: 0.5;
}

.punto.active {
	opacity: 1;
}

.capaFlecha {
	position: absolute;
	display: block;
	top: 50%;
	font-size: 3em;
	opacity: 0.5;
	color: white;
	cursor: pointer;
	margin-top: -25px;
}

.capaFlecha:hover {
	opacity: 1;
}
.capaFlecha.siguiente {
	right: 10px;
}

.capaFlecha.anterior {
	left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/modulos/muro/vue/componentes/publicacion/contenidoMultimedia.vue